import React from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@mui/material";

const OtherServicesCard = ({ title, image }) => {
  return (
    <motion.div whileHover={{ scale: 1.05 }} className="w-full md:w-1/4 p-4 ">
      <Card className="shadow-md rounded-lg flex flex-col items-center p-4 hover:border-2 hover:border-green-700">
        <div className="flex justify-center items-center w-full h-48">
          <img src={image} alt={title} className="w-32 h-32 object-contain" />
        </div>
        <CardContent className="text-center">
          <p className="font-body text-center text-lg">{title}</p>
          <motion.button
            className="w-full bg-green-700 p-2 text-center rounded-xl text-white font-body mt-4 hover:bg-green-900 "
            whileHover={{ y: 5 }}
          >
            Try Now
          </motion.button>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default OtherServicesCard;
